import moment, {Moment} from "moment";

export interface User {
  _id: any;
  full_name: string;
}

export interface Quotation {
  _id: any;
  number: string;
  notes: string;
  created_at: Moment;
  updated_at: Moment;
  items: Item[];
  allocated_to?: User;
}

export interface Money {
  cents: number;
  currency_iso: string;
}

export interface Item {
  _id: any;
  number: number;
  name: string;
  adjustment: Money;
  components: Component[];
}

export interface Product {
  _id: any;
  name: string;
  description: string;
}

export interface Distance {
  micrometres: number;
}

export interface Component {
  id: string;
  product: Product;
  number: number;
  quantity: number;
  length_distance: string;
  width_distance: string;
  length: Distance;
  width: Distance;
  square_metre: number;
  bulk_purchase: boolean;
  product_cost: Money;
  product_price: Money;
  product_description: string;
}

export function parseQuotation(data: any) {
  const quotation = data as Quotation;
  quotation.created_at = moment(data.created_at);
  quotation.updated_at =  moment(data.updated_at);
  return quotation;
}

export function blankQuotation() {
  return {} as Quotation;
}
